// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function () {

    // Select all anchor tags with href attributes starting with "#"
    const anchors = document.querySelectorAll('a[href^="#"]:not(.footnote-label)');

    anchors.forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            // Prevent the default link click behavior
            e.preventDefault();

            // Get the target element
            let target = document.querySelector(this.getAttribute('href'));

            // Set the offset based on the screen width
            let offset = window.innerWidth < 992 ? 250 : 150;

            // If the target element is found
            if (target) {
                // Calculate the position of the element and adjust with the offset
                let targetPos = target.getBoundingClientRect().top + window.scrollY;

                // Scroll to the adjusted position with a smooth behavior
                window.scrollTo({
                    top: targetPos - offset,
                    behavior: 'smooth',
                });
            }
        });
    });


    //Table of Content Toggle
    initializeScrollSpy();
	let sidebarTitle = document.querySelector('#toc .sidebar-title');
	if (sidebarTitle) {
		const toc = document.querySelector('#table-of-contents');
		const currentToc = document.querySelector('#current-toc');

		sidebarTitle.addEventListener('click', function () {
			if (toc.style.maxHeight) {
				toc.style.maxHeight = null;
				toc.style.overflowY = "visible";
				currentToc.style.display = "block";
			} else {
				toc.style.maxHeight = toc.scrollHeight > 100 ? "100px" : toc.scrollHeight + "px";
				toc.style.overflowY = "auto";
				currentToc.style.display = "none";
			}
		});

		document.querySelectorAll('.single-content h2').forEach(function (h2) {
			if (!h2.id) {
				var text = h2.textContent || h2.innerText;
				h2.id = createSlug(text);
			}
		});

		let moveTOC = function () {
			const toc = document.getElementById('toc');
			const content = document.querySelector('.single-content');
			const contentParent = document.querySelector('.content-sidebar-wrapper');
			const entryHeader = document.querySelector('.entry-header');
			const hasCoverHeader = entryHeader && entryHeader.querySelector('.wp-block-cover');
			if (window.innerWidth < 992) {
				if (hasCoverHeader) {
					contentParent.insertBefore(toc, content);
				} else if (entryHeader) {
					entryHeader.insertAdjacentElement('afterend', toc);
				}
			} else {
				const sidebar = document.querySelector('.sidebar .has-sticky');
				sidebar.insertBefore(toc, sidebar.firstChild);
			}
		}

		moveTOC();
		window.addEventListener('resize', moveTOC);

		// Add event listener to hide TOC and show current TOC on click of an li
		document.querySelectorAll('#table-of-contents li a').forEach(function (link) {
			link.addEventListener('click', function (event) {
				event.preventDefault(); // Prevent default link behavior
				toc.style.maxHeight = null;
				toc.style.overflowY = "visible";
				currentToc.style.display = "block";
				currentToc.textContent = link.textContent; // Update the current TOC text

				// Scroll to the target h2 element
				const targetId = link.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);
				if (targetElement) {
					targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}

				// Update active class manually
				document.querySelectorAll('#table-of-contents li a').forEach(link => {
					link.classList.remove('active');
				});
				link.classList.add('active');
			});
		});
	}

    const menuItems = document.querySelectorAll('.sidebar-menu .menu-item-has-children');

    if (menuItems.length) { // Check if there are any menu items to work with
        // Attach only one event listener to the parent menu to handle all clicks using event delegation
        document.querySelector('.sidebar-menu').addEventListener('click', function (event) {
            // Determine if the clicked target or its parents are a menu item
            const targetItem = event.target.closest('.menu-item-has-children');

            if (targetItem) {
                // Toggle open class only if the clicked target isn't a link or within a submenu
                if (!event.target.closest('a')) {
                    targetItem.classList.toggle('open');
                    event.preventDefault(); // Prevent default action for non-link elements
                }
            }
        });
    }

    // Open all parent menus of the current menu item
    const currentItem = document.querySelector('.sidebar-menu .current-menu-item');
    if (currentItem) {
        let ancestors = currentItem.closest('.menu-item-has-children');
        while (ancestors) {
            ancestors.classList.add('open');
            // Move up to the next parent menu item
            ancestors = ancestors.parentElement.closest('.menu-item-has-children');
        }
    }

    //toggle modal form
    let offcanvasElement = document.getElementById('offcanvasModalForm');

    if (offcanvasElement) {
        let modalFormElement = new bootstrap.Offcanvas(offcanvasElement);
        let offcanvasTitle = offcanvasElement.querySelector('h5');

        let treatmentSelectElement = document.getElementById('treatmentToggleModalForm');
        if (treatmentSelectElement) {
            treatmentSelectElement.addEventListener('change', function () {
                if (this.value) {
                    modalFormElement.show(); // Show the offcanvas
                    offcanvasTitle.innerText = 'Find a Leading Treatment Center in ' + this.value;
                }
            });
        }

        let doctorSelectElement = document.getElementById('doctorToggleModalForm');
        if (doctorSelectElement) {
            doctorSelectElement.addEventListener('change', function () {
                if (this.value) {
                    modalFormElement.show(); // Show the offcanvas
                    offcanvasTitle.innerText = 'Find a Leading Doctor in ' + this.value;
                }
            });
        }


        // Now we select the link in .hero which triggers the offcanvas
        let heroButton = document.querySelector('.hero .wp-block-button__link[data-bs-target="#offcanvasModalForm"]');
        if (heroButton) {
            heroButton.addEventListener('click', function () {
                // Grab the data-title attribute and use it to replace the h5 text
                offcanvasTitle.innerText = this.getAttribute('data-title');
            });
        }

        // Select all matching buttons treatment loop
        let treatmentGetInTouchButtons = document.querySelectorAll('.meso_facility a[data-bs-target="#offcanvasModalForm"]');
        if (treatmentGetInTouchButtons) {
            // Loop through each button and add an event listener
            treatmentGetInTouchButtons.forEach(function (treatmentGetInTouchButton) {
                treatmentGetInTouchButton.addEventListener('click', function () {
                    // Grab the data-title attribute and use it to replace the h5 text
                    offcanvasTitle.innerText = 'Get Help Contacting ' + this.getAttribute('data-title');
                });
            });
        }


        // Select all matching buttons doctor loop
        let doctorGetInTouchButtons = document.querySelectorAll('.doctor-contact a[data-bs-target="#offcanvasModalForm"]');
        if (doctorGetInTouchButtons) {
            // Loop through each button and add an event listener
            doctorGetInTouchButtons.forEach(function (doctorGetInTouchButton) {
                doctorGetInTouchButton.addEventListener('click', function () {
                    // Grab the data-title attribute and use it to replace the h5 text
                    offcanvasTitle.innerText = 'Get Help Contacting ' + this.getAttribute('data-title');

                    // Get the doctor's image from the closest lis element
                    let imgElement = doctorGetInTouchButton.closest('li').querySelector('img');
                    if (imgElement) {
                        // If there's an image tag, get its source
                        let imgSrc = imgElement.getAttribute('src');

                        // Check for existing image in offcanvas and remove it
                        let currentImageInCanvas = offcanvasElement.querySelector('img');
                        if (currentImageInCanvas) {
                            currentImageInCanvas.remove();
                        }

                        // Create a new img element and set the source
                        let newImageElement = document.createElement('img');
                        newImageElement.src = imgSrc;

                        // Insert the new image before the h5 tag
                        offcanvasTitle.parentNode.insertBefore(newImageElement, offcanvasTitle);
                    }
                });
            });
        }

        // Select all matching .modal-button  loop
        let modalButtons = document.querySelectorAll('.modal-button');
        if (modalButtons) {
            // Loop through each button and add an event listener
            modalButtons.forEach(function (modalButton) {
                modalButton.addEventListener('click', function () {
                    // Grab the page-title and use it to replace the h5 text
                    offcanvasTitle.innerText = 'Get Help Contacting ' + document.querySelector('.entry-title').innerText;
                    // Create a new Offcanvas instance
                    var offcanvasInstance = new bootstrap.Offcanvas(document.querySelector('#offcanvasModalForm'));
                    // Show the offcanvas
                    offcanvasInstance.show();
                });
            });
        }

        // for single doctor pages
        let singleDoctorButton = document.querySelector('.single-meso_doctor .wp-block-button__link[data-bs-target="#offcanvasModalForm"]');
        if (singleDoctorButton) {
            singleDoctorButton.addEventListener('click', function () {
                // Grab the data-title attribute and use it to replace the h5 text
                offcanvasTitle.innerText = 'Get Help Contacting ' + this.getAttribute('data-title');

                // Get the doctor's image
                let imgElement = document.querySelector('.doctor-image img');
                if (imgElement) {
                    // If there's an image tag, get its source
                    let imgSrc = imgElement.getAttribute('src');

                    // Check for existing image in offcanvas and remove it
                    let currentImageInCanvas = offcanvasElement.querySelector('img');
                    if (currentImageInCanvas) {
                        currentImageInCanvas.remove();
                    }

                    // Create a new img element and set the source
                    let newImageElement = document.createElement('img');
                    newImageElement.src = imgSrc;

                    // Insert the new image before the h5 tag
                    offcanvasTitle.parentNode.insertBefore(newImageElement, offcanvasTitle);
                }
            });
        }

        //for lawyer form
        let lawyerButton = document.querySelector('.sidemenu-parent-lawyer .wp-block-button__link[data-bs-target="#offcanvasModalForm"]');
        if (lawyerButton) {
            lawyerButton.addEventListener('click', function (event) {
                event.preventDefault(); // prevent the default action

                offcanvasTitle.innerText = this.getAttribute('data-title');

                // Check for existing image in offcanvas and remove it
                let currentImageInCanvas = offcanvasElement.querySelector('img');
                if (currentImageInCanvas) {
                    currentImageInCanvas.remove();
                }

                // Create a new img element and set the source
                let newImageElement = document.createElement('img');
                newImageElement.src = this.getAttribute('data-image-src');

                newImageElement.classList.add('has-no-img-style');

                // Insert the new image before the h5 tag
                // Using insertBefore method because insertAfter doesn't exist
                offcanvasTitle.parentNode.insertBefore(newImageElement, offcanvasTitle.nextSibling);
            });
        }

        let financialButton = document.querySelector('.page-id-12774  .wp-block-button__link[data-bs-target="#offcanvasModalForm"]');
        if (financialButton) {
            financialButton.addEventListener('click', function () {
                // Grab the data-title attribute and use it to replace the h5 text
                offcanvasTitle.innerText = this.getAttribute('data-title');
            });
        }
    }


    var errorExists = document.querySelector('.gform_validation_error');
    var confirmationExists = document.querySelector('.gform_confirmation_message');

    // If either error or confirmation message exists, re-open Offcanvas
    if ((errorExists !== null && errorExists.offsetParent !== null) || (confirmationExists !== null && confirmationExists.offsetParent !== null)) {
        var myOffcanvasElement = document.getElementById('offcanvasModalForm'); // Replace 'yourOffcanvasID' with your actual Offcanvas ID
        if (myOffcanvasElement) {
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvasElement);
            bsOffcanvas.show();
        }
    }

    //source and footnotes
    const footnoteLabels = document.querySelectorAll('.footnote-label');

    if (footnoteLabels.length > 0) {
        footnoteLabels.forEach((footnoteLabel) => {
            let findSource = footnoteLabel.getAttribute('href');
            let sourceText = document.querySelector('.sources ' + findSource)?.innerHTML;

            if (sourceText) {
                footnoteLabel.dataset.bsToggle = "popover";
                footnoteLabel.dataset.bsPlacement = "top";
                footnoteLabel.dataset.bsHtml = "true";
                footnoteLabel.dataset.bsContent = sourceText;

                // Initialize the popover
                const popover = new bootstrap.Popover(footnoteLabel, {
                    trigger: 'manual', // Switch to manual triggering
                    animation: true,
                    html: true, // Make sure HTML content is enabled
                    content: sourceText
                });

                let isPopoverHovered = false;

                // Show the popover when the trigger element is hovered
                footnoteLabel.addEventListener('mouseenter', function () {
                    popover.show();

                    // Check if the popover content is hovered
                    setTimeout(() => { // Timeout ensures the popover is in the DOM
                        const popoverNode = document.querySelector('.popover');
                        if (popoverNode) {
                            popoverNode.addEventListener('mouseenter', () => isPopoverHovered = true);
                            popoverNode.addEventListener('mouseleave', () => {
                                isPopoverHovered = false;
                                popover.hide(); // Hide the popover when mouse leaves the popover content
                            });
                        }
                    }, 10);
                });

                // Hide the popover when the mouse leaves the trigger element and the popover content
                footnoteLabel.addEventListener('mouseleave', function () {
                    setTimeout(() => {
                        if (!isPopoverHovered) {
                            popover.hide();
                        }
                    }, 10);
                });
            }
        });
    }

    // Get the source toggle and overlay elements
    let sourceToggle = document.querySelector('.source-toggle');
    let sourcesEl = document.querySelector('.sources .has__overlay');

    if (sourceToggle && sourcesEl) {
        sourceToggle.addEventListener('click', function (event) {
            event.preventDefault();
            if (sourcesEl.classList.contains('minimized')) {
                sourcesEl.classList.remove('minimized');
            } else {
                sourcesEl.classList.add('minimized');
            }
        });
    }

    //search bar toggle
    const searchIcon = document.querySelector('.search-icon');
    const searchBlock = document.querySelector('.search-block');

    if (searchIcon && searchBlock) {
        searchIcon.addEventListener("click", function (e) {
            e.preventDefault();

            // Toggle body class
            document.body.classList.toggle('has-search-active');

            // Slide toggle search block
            if (searchBlock.style.maxHeight) {
                searchBlock.style.maxHeight = null;
            } else {
                searchBlock.style.maxHeight = searchBlock.scrollHeight + "px";
            }

            // Change icon
            let icon = this.querySelector('i');
            if (icon.classList.contains('fa-magnifying-glass')) {
                icon.classList.remove('fa-magnifying-glass');
                icon.classList.add('fa-close');
            } else {
                icon.classList.remove('fa-close');
                icon.classList.add('fa-magnifying-glass');
            }
        });
    }

    //off canvas menu items


    let offcanvasMainMenuSearch = function () {
        var menus = document.querySelectorAll('#main-nav .menu-item-has-children > a');

        var searchForm = document.querySelector('.search-block');
        var offcanvasMainNav = document.querySelector('#main-menu');

        if (window.innerWidth <= 1200) {
            menus.forEach(function (menu) {
                menu.addEventListener('click', function (e) {
                    var parentMenu = this.parentNode;
                    var subMenu = parentMenu.querySelector('.dropdown-menu');

                    if (!parentMenu.classList.contains('menu-open')) {
                        e.preventDefault();
                        subMenu.style.display = (subMenu.style.display === 'none' || subMenu.style.display === '') ? 'block' : 'none';
                        parentMenu.classList.add('menu-open');
                    }
                });
            });

            if (searchForm && offcanvasMainNav) {
                offcanvasMainNav.insertAdjacentElement('afterend', searchForm);
            }

        } else {
            menus.forEach(function (menu) {
                var parentMenu = menu.parentNode;
                var subMenu = parentMenu.querySelector('.dropdown-menu');
                subMenu.style.display = '';
                parentMenu.classList.remove('menu-open');
            });

            if (searchForm) {
                var originalPosition = document.querySelector('#main-nav');
                if (originalPosition) {
                    originalPosition.insertAdjacentElement('afterend', searchForm);
                }
            }
        }
    }

    offcanvasMainMenuSearch();
    window.addEventListener('resize', offcanvasMainMenuSearch);

    //add cta button before author block
    let authorBlocks = document.querySelectorAll('.author-block.is-writer');
    let faqBlocks = document.querySelectorAll('.faq_block');

    // List of page-ids to exclude
    let excludedPagesIds = ['page-id-5812', 'page-id-31930', 'page-id-31960', 'page-id-31970', 'page-id-31986', 'page-id-31993', 'page-id-32010', 'page-id-32022', 'page-id-32032', 'page-id-32033', 'page-id-32085', 'page-id-32117', 'page-id-32132', 'page-id-32141', 'page-id-32149', 'page-id-32159', 'page-id-32173', 'page-id-32181', 'page-id-32193', 'page-id-32215', 'page-id-32225', 'page-id-32238', 'page-id-32260', 'page-id-32408', 'page-id-32412', 'page-id-32418', 'page-id-32422', 'page-id-32483', 'page-id-32492', 'page-id-32498', 'page-id-32502', 'page-id-32508', 'page-id-32512', 'page-id-32521', 'page-id-32537', 'page-id-32553', 'page-id-32558', 'page-id-32562', 'page-id-32570', 'page-id-32581', 'page-id-32577', 'page-id-32586', 'page-id-32592', 'page-id-32599', 'page-id-32603', 'page-id-32620', 'page-id-32684', 'page-id-32689', 'page-id-32693', 'page-id-32705', 'page-id-32713', 'page-id-32717', 'page-id-32722']  ;

    // Get the body element's classes in an array
    let bodyClasses = Array.from(document.body.classList);

    // Check if any of the excluded page-ids are present in bodyClasses
    let isExcludedPage = bodyClasses.some(className => excludedPagesIds.includes(className));

    // Only create buttons if there are no .faq_block elements on the page and page is not excluded
    if (faqBlocks.length === 0 && !isExcludedPage) {
        authorBlocks.forEach((authorBlock) => {
            let newDiv = document.createElement('div');
            newDiv.innerHTML = `
            <div class="wp-block-buttons">
               <div class="wp-block-button has-arrow">
                   <a class="wp-block-button__link has-blue-color has-yellow-background-color has-text-color has-background has-link-color wp-element-button" href="/mesothelioma-resources/" rel="noreferrer noopener">FREE Mesothelioma Packet</a>
               </div>
            </div>
            `;
            authorBlock.parentNode.insertBefore(newDiv, authorBlock);
        });
    }

});

function initializeScrollSpy() {
	const sections = document.querySelectorAll('.single-content h2');
	const currentToc = document.querySelector('#current-toc');
	const tocLinks = document.querySelectorAll('#table-of-contents li a');

	if (!currentToc || !tocLinks.length) return;

	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0.5 // Trigger when 50% of the h2 is in the viewport
	};

	// Track intersection state per section (callbacks can fire per-element)
	const intersectingSections = new Map();

	const updateActiveSection = () => {
		if (intersectingSections.size === 0) return;
		const topmost = [...intersectingSections.entries()]
			.sort((a, b) => a[1].top - b[1].top)[0];
		const id = topmost[0];
		const activeLink = document.querySelector(`#table-of-contents li a[href="#${id}"]`);
		if (activeLink) {
			tocLinks.forEach((link) => link.classList.remove('active'));
			activeLink.classList.add('active');
			currentToc.textContent = activeLink.textContent;
		}
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const id = entry.target.id;
			if (entry.isIntersecting) {
				intersectingSections.set(id, { top: entry.boundingClientRect.top });
			} else {
				intersectingSections.delete(id);
			}
		});
		updateActiveSection();
	}, options);

	sections.forEach((section) => observer.observe(section));

	// Set first section as default on page load (before observer may fire)
	tocLinks[0].classList.add('active');
	currentToc.textContent = tocLinks[0].textContent;
}


function createSlug(text) {
    // Strip any HTML tags (not usually necessary with textContent)
    text = text.replace(/<\/?[^>]+(>|$)/g, "");

    // Remove footnotes
    text = text.replace(/\[\s*footnote\s.*?\]/gi, "");

    // Convert to lowercase
    text = text.toLowerCase();

    // Non-alpha numeric characters to dashes
    text = text.replace(/[^a-z0-9]+/g, '-');

    // Remove leading and trailing dashes
    text = text.replace(/(^-|-$)/g, '');

    return text;
}